import React from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";

const LegalShell = ({ children }) => (
  <section className="py-16 md:py-24">
    <div className="max-w-3xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="space-y-8 text-[#475569] leading-relaxed text-[15px]">{children}</div>
      </Reveal>
    </div>
  </section>
);

const H = ({ children }) => <h2 className="font-serif font-bold text-xl text-[#0A2B3D] pt-4">{children}</h2>;

export const PrivacyPolicy = () => (
  <div data-testid="privacy-page">
    <PageHero kicker="Legal" lines={[<span key="a">Privacy Policy</span>]} intro="Effective January 1, 2026 · American Elm Advisors, LLC" />
    <LegalShell>
      <p>American Elm Advisors, LLC ("American Elm," "we," "our") respects the privacy of visitors to our website. This policy describes what information we collect and how we use it.</p>
      <H>Information We Collect</H>
      <p>When you submit a consultation or contact form, we collect the information you provide: your name, firm name, email address, telephone number, professional role, services of interest, and the content of your message. We do not collect sensitive personal information through this website.</p>
      <H>How We Use Information</H>
      <p>We use the information you provide solely to respond to your inquiry, discuss potential engagements, and communicate about our services. We do not sell, rent, or share your information with third parties for their marketing purposes.</p>
      <H>Data Retention & Security</H>
      <p>Inquiry records are retained only as long as needed to address your request and meet any legal or regulatory obligations. We apply reasonable administrative and technical safeguards to protect information submitted through this site.</p>
      <H>Third-Party Links</H>
      <p>This site links to third-party websites, including LinkedIn and our affiliate firms. We are not responsible for the privacy practices of those sites.</p>
      <H>Contact</H>
      <p>Questions about this policy may be directed to American Elm Advisors, 104 Congress Street, Suite 404, Portsmouth, NH 03801, through the contact form on this site.</p>
    </LegalShell>
  </div>
);

export const TermsConditions = () => (
  <div data-testid="terms-page">
    <PageHero kicker="Legal" lines={[<span key="a">Terms & Conditions</span>]} intro="Effective January 1, 2026 · American Elm Advisors, LLC" />
    <LegalShell>
      <p>By accessing this website, you agree to the following terms. If you do not agree, please do not use this site.</p>
      <H>Informational Purposes Only</H>
      <p>The content of this website is provided for general informational purposes. It does not constitute legal, compliance, investment, or tax advice, and it does not create a consulting, fiduciary, attorney-client, or advisory relationship. Engagement with American Elm Advisors occurs only through a written agreement.</p>
      <H>No Offer or Solicitation</H>
      <p>Nothing on this site constitutes an offer to sell or a solicitation of an offer to buy any security. References to Rule 506(b), Rule 506(c), or other regulatory frameworks are descriptive of our consulting services only.</p>
      <H>Intellectual Property</H>
      <p>All content, marks, and materials on this site are the property of American Elm Advisors, LLC and may not be reproduced without written permission.</p>
      <H>Limitation of Liability</H>
      <p>American Elm Advisors is not liable for any damages arising from use of, or reliance on, this website or its content.</p>
      <H>Contact</H>
      <p>American Elm Advisors, 104 Congress Street, Suite 404, Portsmouth, NH 03801.</p>
    </LegalShell>
  </div>
);
